module.exports = __webpack_public_path__ + "img/voucher-tag.b742ff7.svg";